import { PaginationControls } from "@/domains/documents/components/molecules/PaginationControls";
import { DocumentListHeader } from "@/domains/documents/components/organisms/DocumentListHeader";
import { observer } from "mobx-react-lite";
import type { ComponentProps } from "react";
import type { DocumentTablePresentation } from "./documentTablePresentation";
type TableHeaderProps = DocumentTablePresentation;
export const TableHeader = observer(function TableHeader(props: TableHeaderProps) {
  const {
    handleSelectAll,
    allVisibleSelected,
    someVisibleSelected,
    showCheckbox,
    showVersion,
    showDateCreated,
    showStatus,
    showUser,
    showTags,
    showParent,
    showActions,
    resultCountLabel,
    showPaginationControls,
  } = props;
  return (
    <DocumentListHeader
      onSelectAll={handleSelectAll}
      isAllSelected={allVisibleSelected ?? false}
      isIndeterminate={someVisibleSelected && !allVisibleSelected}
      showCheckbox={showCheckbox}
      showVersion={showVersion}
      showDateCreated={showDateCreated}
      showStatus={showStatus}
      showUser={showUser}
      showTags={showTags}
      showParent={showParent}
      showActions={showActions}
      {...tableHeaderSorting(props)}
      endContent={
        resultCountLabel || showPaginationControls ? <TableHeaderCounts {...props} /> : undefined
      }
    />
  );
});

export const TableHeaderCounts = observer(function TableHeaderCounts(
  props: DocumentTablePresentation
) {
  const { resultCountLabel, showPaginationControls, paginationProps, showLoadingOverlay } = props;
  return (
    <div className="flex items-center justify-end gap-3">
      {resultCountLabel && (
        <span
          className="min-w-[9rem] whitespace-nowrap text-right text-sm font-medium text-muted-foreground"
          aria-live="polite"
        >
          {resultCountLabel}
        </span>
      )}
      {showPaginationControls && paginationProps && (
        <PaginationControls
          {...paginationProps}
          isLoading={showLoadingOverlay}
          className="min-w-[13rem] justify-end"
        />
      )}
    </div>
  );
});

function tableHeaderSorting(
  props: TableHeaderProps
): Pick<ComponentProps<typeof DocumentListHeader>, "sortKey" | "sortOrder" | "onSort"> {
  const { docFiltersContext } = props;
  return {
    sortKey: docFiltersContext?.filters.sortKey,

    sortOrder: docFiltersContext?.filters.sortOrder,

    onSort: docFiltersContext
      ? (key) => {
          if (docFiltersContext.filters.sortKey === key) {
            docFiltersContext.setSortOrder(
              docFiltersContext.filters.sortOrder === "asc" ? "desc" : "asc"
            );
          } else {
            docFiltersContext.setSortKey(key);
            docFiltersContext.setSortOrder("asc");
          }
        }
      : undefined,
  };
}
